__turbopack_context__.v({
  "body": "Intro-module-scss-module__Us2CNq__body",
  "chip": "Intro-module-scss-module__Us2CNq__chip",
  "chipWrapper": "Intro-module-scss-module__Us2CNq__chipWrapper",
  "darkBg": "Intro-module-scss-module__Us2CNq__darkBg",
  "hasBackground": "Intro-module-scss-module__Us2CNq__hasBackground",
  "hero": "Intro-module-scss-module__Us2CNq__hero",
  "icon": "Intro-module-scss-module__Us2CNq__icon",
  "innerChip": "Intro-module-scss-module__Us2CNq__innerChip",
  "link": "Intro-module-scss-module__Us2CNq__link",
  "title": "Intro-module-scss-module__Us2CNq__title",
  "wrapper": "Intro-module-scss-module__Us2CNq__wrapper",
});
